// extracted by mini-css-extract-plugin
module.exports = {"title":"ConsentItem_title__2kyVz","titleWithdrawn":"ConsentItem_titleWithdrawn__2kVL-","date":"ConsentItem_date__lEMpj","container":"ConsentItem_container__j-3aD"};